import React, {Component} from 'react';
import moment   from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,imagesFormatter,
    dateFormatter,
    customTableSelect,
    historyDataFormatter,convertToHoursAndMinutes,
    customFormatter,linkFormatter,
    getFieldByPathFormatter
} from 'util/Utils';
 import IoCheckmark from 'react-icons/lib/io/checkmark';
import HistoryDataModal   from 'shared/HistoryDataModal'
import FaFileTextO from 'react-icons/lib/fa/file-text-o';
import {Link} from 'react-router';
import { Button } from 'react-bootstrap';
import config from  '../../../config';
import {
    UPDATE_ADMIN_PRODUCT, DELETE_ADMIN_PRODUCT, ADD_SELECTED_PRODUCTS,
    REMOVE_SELECTED_PRODUCTS, ADD_SELECTED_SERVICES, REMOVE_SELECTED_SERVICES, CLEAR_SELECTED_SERVICES
} from "actions/actionTypes";

class AdminServiceListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},
        };
    }

    componentWillMount() {

    }

    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = []
      if (!(row.Status == 'Cancelled' && moment(row.ServiceStartTime).isBefore(moment()))) {
            menuItemsMap.push({onClick: 'editRecord', label: 'Edit'})
       }
        if (row.Status !== 'Cancelled') {

             menuItemsMap.push({
                onClick: (row) => {
                    this.props.showRemoveDialog({...row, actionToProcess:'cancel'})
                }, label: 'Cancel'
            })
        }
        if (!row.Deleted) {
            menuItemsMap.push({onClick: 'showRemoveDialog', label: 'Delete'})
        }
        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }

    onRowSelect(row, isSelected, e) {
        var actionName = isSelected ? ADD_SELECTED_SERVICES : REMOVE_SELECTED_SERVICES;
        this.props.dispatchAction([row], actionName)
    }

    onAllRowSelect(isSelected, rows) {
        var actionName = isSelected ? ADD_SELECTED_SERVICES : REMOVE_SELECTED_SERVICES;
        this.props.dispatchAction(rows, actionName)
    }

    customMultiSelect(props) {
        return customTableSelect(props, {
            table: this.refs.table,
            selectedRows: this.props.adminServices.selectedRecords
        });
    }


    editRecord(row) {
        this.props.editRecord(row);
    }

    cancelRecord(row) {
        this.props.cancelRecord(row);
    }

    showRemoveDialog(row) {
        this.props.showRemoveDialog(row)
    }

    formatTimeWindow(cell, row, extra) {
        if (row.TimeWindow && row.Type) {
            var foundItem = _.find(config.services.timeWindowOptions, {value: row.TimeWindow})

            return foundItem ? foundItem.label : row.TimeWindow;
        } else {
            return ''
        }
    }

    customDateFormatter(cell, row, extra) {

        if (_.get(row, 'CalendarEvent.CalendarEventLink')) {
            return <a target="_blank"
                      href={_.get(row, 'CalendarEvent.CalendarEventLink') }>{ dateFormatter(cell, row, extra)}</a>

        } else {
            return dateFormatter(cell, row, extra)
        }
    }

    formatSize(cell, row, extra) {
        if (row.Size && row.Type) {
            var foundItem = _.find(config.services[row.Type.toLowerCase()].sizeOptions, {value: row.Size})
            return foundItem ? foundItem.internalLabel : row.Size;
        } else {
            return ''
        }
    }

    hideHistoryDataModal() {
        this.setState({currentRecord: {}, historyDataModalVisible: false});
    }


    onProductsTotalChange(row, cellName, cellValue) {
        var self = this;
        if (cellName == 'TotalProductsNumber') {
            if (isNaN(cellValue)) {
                this.props.displayMessage({'messageCode': 'Please, specify correct total products number'});
                return false;
            }

            self.props.makeRequest({TotalProductsNumber: cellValue}, {
                "endpoint": "/pickups" + '/' + encodeURIComponent(row._id),
                type: "patch",
            }).then(pickupUpdateResponse => {
                self.props.search()
            }).catch(err => {

            });
        }
    }

    pickupNumberFormatter(cell, row, field) {
        if (_.get(row, ['ServiceCustomData', 'ServiceSizeNotes']) || _.get(row, ['ServiceCustomData', 'ContactUserForServiceSize'])) {
            return (
                <div>
                    <div>{row.PickupNumber}</div>
                    <Link className="cursor-pointer" onClick={() => this.setState({
                        currentRecord: _.extend({}, row, {currentField: 'ServiceCustomData', modalTitle: 'Details'}),
                        historyDataModalVisible: true
                    })}
                    ><FaFileTextO style={{fontSize: 18}}></FaFileTextO></Link>
                </div>)
        } else {
            return (
                <div>{row.PickupNumber}</div>
            );

        }

    }

    render() {
        //      console.log('state', this.state  );
        return (
            <div className=" databases-table">
                <BootstrapTable data={this.props.data} ref='table'
                                selectRow={  {
                                    mode: 'checkbox',
                                    columnWidth: '29px',
                                    onSelect: this.onRowSelect.bind(this),
                                    onSelectAll: this.onAllRowSelect.bind(this),
                                    customComponent: this.customMultiSelect.bind(this)
                                } }
                                remote={ true }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }
                                cellEdit={ {
                                    mode: 'dbclick',
                                    blurToSave: true,
                                    beforeSaveCell: this.onProductsTotalChange.bind(this), // a hook for before saving cell
                                } }
                >
                    <TableHeaderColumn width="40px" dataAlign="center" dataField='Type'
                                       dataFormat={ customFormatter } formatExtraData={ {
                     path: ['getObject'], format: (row) => {
                       return <div>
                         {row.Type}
                         {row.HasUsedCarSeat &&
                            <img  className="top5" style={{width:25, height: 25}}   src={`${config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : ''}/theme/assets/car_seat.png`} />
                          }
                       </div>;
                        }
                    }}    editable={ false } dataSort={true}>Type</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataAlign="center" dataField='PickupNumber'
                                       dataFormat={this.pickupNumberFormatter.bind(this)}
                                       editable={ false } dataSort={true}>&#8470;</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataField="ServiceStartTime" dataAlign="center"
                                       dataFormat={ this.customDateFormatter.bind(this) }
                                       editable={ false }
                                       formatExtraData={ {'name': 'ServiceStartTime', 'format': 'MM/DD'} }
                                       dataSort={true}>Date</TableHeaderColumn>
                    <TableHeaderColumn width="55px" dataFormat={this.formatTimeWindow.bind(this)} dataField='TimeWindow'
                                       dataAlign="center" dataSort={true}>Time</TableHeaderColumn>

                    <TableHeaderColumn columnClassName={'break-word'}  tdStyle={ { whiteSpace: 'normal' } } thStyle={ { whiteSpace: 'normal' } } width="90px"
                                       editable={ false }
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                                           format: (row) => {
                                               return <div>
                                                       <div style={{ }}>{_.get(row, ['SellerID', 'DisplayName'],'')}</div>
                                                       <div className="top4 green">{'+1'+_.get(row,  ['SellerID', 'PhoneNumber', 'Number'],'')}</div>

                                               </div>}}}

                                       // formatExtraData={ {path: ['SellerID', 'DisplayName']}}
                                       // dataFormat={ getFieldByPathFormatter }
                                       dataField='SellerID.DisplayName' dataAlign="center"
                                       dataSort={true}>Seller</TableHeaderColumn>
                    <TableHeaderColumn width="35px" formatExtraData={ {path: ['SellerID', 'Payout']}}
                                       editable={ false } dataFormat={ getFieldByPathFormatter }
                                       dataField='SellerID.Payout' dataAlign="center" dataSort={true}>Seller
                        Payout</TableHeaderColumn>
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='SellerPickupNumber'
                                       editable={ false } dataSort={true}>Pickup</TableHeaderColumn>
                    <TableHeaderColumn width="30px" dataAlign="center" dataField="Notifications"
                                       editable={ false } dataSort={true}
                                       dataFormat={(cell, row) => historyDataFormatter.call(this, row, {field: 'Notifications'})}>Notification</TableHeaderColumn>
                    <TableHeaderColumn width="30px" dataAlign="center" dataField="ChangeLog"
                                       editable={ false } dataSort={true}
                                       dataFormat={ (cell, row) => historyDataFormatter.call(this, row, {field: 'ChangeLog'}) }>Log</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataAlign="center" dataField='Size'
                                       dataFormat={this.formatSize.bind(this)}
                                       editable={ false } dataSort={true}>Size</TableHeaderColumn>
                    <TableHeaderColumn width="65px"
                                       columnClassName={  'table-cell-with-image' }
                                       dataFormat={(cell, row, columnIndex, rowIndex) => {
                                           return imagesFormatter.call(this,  row,  rowIndex,{
                                               displayMultipleImages:true,
                                              imagePath:   ['ServiceImages'],
                                               total:this.props.total,
                                               perPage:this.state.perPage,
                                               currentPage:this.props.currentPage,
                                           } )
                                       }}
                                       dataField="ServiceImages"
                                       dataAlign="center"
                                       dataSort={true}>
                        Images
                    </TableHeaderColumn>
                    <TableHeaderColumn width="70px"
                                       editable={ false } dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path:[  'getObject'] ,
                                           format: (record) => {
                                               return <div>
                                                   <div>   {_.get(record, 'PickupAddress.Street') ? _.get(record, 'PickupAddress.Street') + (_.get(record, 'PickupAddress.UnitOrSuiteNumber')? ' #' +_.get(record, 'PickupAddress.UnitOrSuiteNumber') : '')+' '+ _.get(record, 'PickupAddress.City') : ''}</div>
                                                 <div className="text-bold green">{_.get(record, 'MarketName','')}</div>
                                                   </div>
                                           }
                                       }}
                                       dataField='PickupAddress.Street' dataAlign="center"
                                       dataSort={true}>Address</TableHeaderColumn>
                    <TableHeaderColumn  columnClassName={'break-word'}  tdStyle={ { whiteSpace: 'normal' } } thStyle={ { whiteSpace: 'normal' } } width="70px"
                                       editable={ false } dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['ServiceCustomData', 'UserPromoCode'], path2: ['PickupAddress', 'City'],
                                           format: (value1, value2) => {
                                               if (value1) {
                                                   return value1
                                               } else {
                                                   return ''
                                               }
                                           }
                                       }}
                                       dataField='ServiceCustomData.UserPromoCode' dataAlign="center"
                                       dataSort={true}>Promo code used</TableHeaderColumn>
                    <TableHeaderColumn dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                       hiddenOnInsert>Id</TableHeaderColumn>

                    {/*<TableHeaderColumn width="50px" dataField='Deleted' dataFormat={this.formatDeleted.bind(this)}  dataAlign="center"dataSort={true}>Deleted</TableHeaderColumn>*/}
                    {/*<TableHeaderColumn width="40px"  dataAlign="center" dataField='MarketName'*/}
                    {/*dataSort={true}>Location</TableHeaderColumn>*/}
                    <TableHeaderColumn width="50px" dataAlign="center" dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                                           format: (row) => {
                                               var statusFieldChanges =_.filter(_.get(row,'ChangeLog',[]), {FieldChanged:'Status'})
                                               if (_.includes(['Hold Donations For Pickup','Out For Approval'],row.Status)   && _.size(statusFieldChanges)>1){
                                                   var lastStatusChange =_.findLast(statusFieldChanges,{FieldChanged:'Status', To:row.Status})

                                                   var duration = moment.duration(moment().diff(moment(lastStatusChange.createdAt)))
                                                   var hoursOrDays = convertToHoursAndMinutes(duration,{format:duration.asHours()>24 ? 'days':'hours'})
                                                   return <div>
                                                       <div>{row.Status}</div>
                                                       <div className="orange top5">{hoursOrDays}</div>
                                                   </div>
                                               }else{
                                                   return row.Status
                                               }


                                           }
                                       }}
                                       editable={ false } dataSort={true}>Status</TableHeaderColumn>

                    {/*<TableHeaderColumn width="60px" dataField='FeesTotalNumber'*/}
                    {/*                   dataFormat={(cell, row, extra)=>{*/}
                    {/*                       if(_.get(row, 'FeesTotalNumber')>0){*/}
                    {/*                                     return linkFormatter(cell, row, extra)*/}
                    {/*                       }*/}
                    {/*                   } }*/}
                    {/*                   formatExtraData={ {*/}
                    {/*                       labelPath: ['FeesTotalNumber'],*/}
                    {/*                       path: 'getObject',*/}
                    {/*                       formatPathValue:(row)=>{*/}
                    {/*                           var recordIDs = _.map(_.get(row,  'FeesRecords',[]), item=>{*/}
                    {/*                               return  'recordIDs='+ encodeURIComponent(item._id)*/}
                    {/*                           })*/}
                    {/*                           return      recordIDs.join('&')*/}
                    {/*                       },*/}
                    {/*                       placeholder: '[queryParams]',*/}
                    {/*                       template: config.getEnvironment().serverBaseURL +'/admin/payout-registry?[queryParams]',*/}
                    {/*                   }  }*/}
                    {/*                   dataAlign="center"*/}
                    {/*>Fees</TableHeaderColumn>*/}
                    {/*<TableHeaderColumn dataAlign="center" width="40px" dataField='ProductsTotalNumber'*/}
                    {/*    // editable={ {type: 'textarea'} }*/}
                    {/*                   dataFormat={(cell, row, extra)=>{*/}
                    {/*                       if (_.get(row, extra.labelPath, 0) >0) {*/}
                    {/*                           return linkFormatter(cell, row, extra)*/}
                    {/*                       } else {*/}
                    {/*                           return <div>{_.get(row, extra.labelPath, extra.label ? extra.label : 'Link')} </div>*/}
                    {/*                       }*/}

                    {/*                   } }*/}
                    {/*                   formatExtraData={ {*/}
                    {/*                       labelPath: ['ProductsTotalNumber'],*/}
                    {/*                       path: ['_id'],*/}
                    {/*                       formatPathValue:(value)=>{*/}
                    {/*                           return   encodeURIComponent(value)*/}
                    {/*                       },*/}
                    {/*                       placeholder: '[service_id]',*/}
                    {/*                       template: config.getEnvironment().serverBaseURL +'/admin/products?ServiceID=[service_id]',*/}
                    {/*                   }  }*/}
                    {/*># Of Products</TableHeaderColumn>*/}
                    {/*<TableHeaderColumn dataAlign="center" width="40px" dataField='PrelistingsTotalNumber'*/}
                    {/*                   dataFormat={(cell, row, extra)=>{*/}
                    {/*                      var troubleshootingRoomProducts =_.filter(_.get(row, 'ServiceProducts',[]), item=>{*/}
                    {/*                         return _.find(  _.get(item, 'ProductVariations',  []) , item=>{*/}
                    {/*                              return item.label =='QualityCheckInstructions' && item.value =='[TROUBLESHOOTING ROOM]'*/}
                    {/*                          })*/}

                    {/*                      })*/}
                    {/*                       if (troubleshootingRoomProducts.length){*/}
                    {/*                          row.troubleshootingRoomProductsTotal= troubleshootingRoomProducts.length*/}
                    {/*                      }*/}
                    {/*                    var troubleshootingRoomProductsExtra=   {*/}
                    {/*                           getLabel: (row)=>{*/}
                    {/*                               return   _.get(row,'troubleshootingRoomProductsTotal')*/}
                    {/*                           },*/}
                    {/*                               path: 'getObject',*/}
                    {/*                            linkStyle:{color:'red'},*/}
                    {/*                           formatPathValue:(row)=>{*/}
                    {/*                           return   encodeURIComponent(row._id)*/}
                    {/*                       },*/}
                    {/*                           placeholder: '[service_id]',*/}
                    {/*                           template: config.getEnvironment().serverBaseURL +'/admin/products?ServiceID=[service_id]&listingStatuses=Troubleshooting',*/}
                    {/*                       }*/}
                    {/*                   return <div>*/}
                    {/*                       { extra.getLabel(row) >0  ?  linkFormatter(cell, row, extra) : <div>{extra.getLabel(row)} </div>}*/}
                    {/*                       {troubleshootingRoomProducts.length > 0 &&*/}
                    {/*                       <div style={{marginTop:10}}  >*/}
                    {/*                            {  linkFormatter(cell, row, troubleshootingRoomProductsExtra)}*/}
                    {/*                           <div style={{fontSize:12,whiteSpace:'unset',color:'red'}}>*/}
                    {/*                               {  linkFormatter(cell, row,_.extend(troubleshootingRoomProductsExtra, {getLabel: (row)=>{*/}
                    {/*                                   return   'Trouble'*/}
                    {/*                               }}))}</div>*/}
                    {/*                        </div>*/}
                    {/*                       }*/}

                    {/*                       </div>*/}
                    {/*                       }}*/}


                    {/*                   formatExtraData={ {*/}
                    {/*                       getLabel: (row)=>{*/}
                    {/*                           return   _.get(row,'PrelistingsTotalNumber')*/}
                    {/*                       },*/}
                    {/*                       path: 'getObject',*/}
                    {/*                       formatPathValue:(row)=>{*/}
                    {/*                           return   encodeURIComponent(row._id)*/}
                    {/*                       },*/}
                    {/*                       placeholder: '[service_id]',*/}
                    {/*                       template: config.getEnvironment().serverBaseURL +'/admin/products?ServiceID=[service_id]&listingStatuses=Prelistings&listingStatuses=PrePrelistings',*/}
                    {/*                   }  }*/}

                    {/*># Of Prelistings</TableHeaderColumn>*/}
                    <TableHeaderColumn width="20px" dataAlign="center" columnClassName={'actions-column'}
                                       editable={ false }
                                       dataFormat={ this.customActionsFormatter.bind(this) }>Actions</TableHeaderColumn>
                </BootstrapTable>
                <HistoryDataModal data={this.state.currentRecord}
                                  hideModal={this.hideHistoryDataModal.bind(this)}
                                  show={this.state.historyDataModalVisible}></HistoryDataModal>
            </div>
        );
    }
}


export default AdminServiceListTable;
